module.exports = __webpack_public_path__ + "static/media/liveroom-income-icon.d2bc60af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/liveroom-income-icon.png
// module id = 2069
// module chunks = 6